import React, { useEffect } from 'react';

import Navbar from '../components/Navbar/Navbar';
import Faq from '../sections/Faq/Faq';
import Footer from '../sections/Footer/Footer';

const FaqSection = () => {
    useEffect(() => {
        document.title =
            'Zahnarzt FAQ – Häufige Fragen | Pankraz & Lichagin';

        document
            .querySelector('meta[name="description"]')
            ?.setAttribute(
                'content',
                'Häufige Fragen rund um Zahnarztbehandlungen, Prophylaxe, Zahnersatz und unsere Zahnarztpraxis Pankraz & Lichagin in Bielefeld.'
            );
    }, []);

    return (
        <>
            <Navbar />
            <Faq />
            <Footer />
        </>
    );
};

export default FaqSection;